import { resolveShellPostMessageTarget } from '@/bridge/shellOrigin';
import { SandboxMessageType, type SandboxReadyMessage } from '@web-studio/shared-schemas';

/** Notify studio-shell that the sandbox bridge is listening for BLOCKS_SYNC. */
export function postSandboxReadyToShell(): void {
  if (typeof window === 'undefined' || window.parent === window) {
    return;
  }

  const message: SandboxReadyMessage = {
    type: SandboxMessageType.SANDBOX_READY,
  };
  window.parent.postMessage(message, resolveShellPostMessageTarget());
}
